export const getTag = (queryTag, tags) => {
  tags = tags.slice();
  let tag = tags.filter((tag) => tag.title === queryTag);

  return tag.slice()[0];
};

export const getCategoryID = (queryTag, categories) => {
  categories = Object.values(categories);
  let category = categories.filter(
    (category) => category.categoryTitle.toLowerCase() === queryTag,
  );
  return category[0] ? category[0].trainingCategoryId : 0;
};

export const getTagValue = (tagData, tagValue) => {
  if (tagData && tagValue) {
    let tag = tagData.values.filter(
      (tag) => tag.title.toLowerCase() === tagValue,
    );
    return tag.slice()[0].valueId;
  }
  return null;
};
